import styled from 'styled-components';

export const StyledScrollableWrapper = styled.div`
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;

  /* Visual cue: shadow gradient ở mép phải báo có thể scroll ngang.
     Note: gradient applies even when content does not overflow. Currently fine because
     wrapper is only used for IndexTable on smDown, which always overflows on mobile. */
  mask-image: linear-gradient(to right, black calc(100% - 24px), transparent 100%);
  -webkit-mask-image: linear-gradient(to right, black calc(100% - 24px), transparent 100%);
`;
